import tooltipFormat from './tooltip';

const getYAxisLabelFormat = decimalPrecision => `{value:.${decimalPrecision}f}`;

const getChartConfig = (options) => {
	const {
		decimalPrecisionLeftYaxis,
		decimalPrecisionRightYaxis,
		showTimeInTooltip,
		leftAxisTitle,
		rightAxisTitle,
		rightSecondaryAxisTitle,
		useOrdinal,
	} = options;

	const config = {
		chart: {
			animation: false,
			panning: false,
			styledMode: true,
			spacing: 0,
		},

		credits: {
			enabled: false,
		},

		legend: {
			enabled: false,
		},

		navigator: {
			enabled: false,
		},

		title: false,

		plotOptions: {
			series: {
				animation: false,

				marker: {
					enabled: false,
				},

				states: {
					hover: {
						halo: false,
					},
				},
			},
		},

		rangeSelector: {
			enabled: false,
		},

		scrollbar: {
			enabled: false,
		},

		tooltip: {
			hideDelay: 0,
			shared: true,
			split: false,
			useHTML: true,
			formatter() {
				return tooltipFormat(
					this,
					showTimeInTooltip,
				);
			},
		},

		xAxis: {
			alternateGridColor: true,
			crosshair: true,
			dateTimeLabelFormats: {
				day: '%e %b',
				second: '%H:%M',
			},
			id: 'x-axis-default',
			minTickInterval: useOrdinal ? null : 1000 * 60 * 30, // Min time span between 2 xAxis items
			type: 'datetime',
			ordinal: useOrdinal,
		},

		yAxis: [
			{
				id: 'y-axis-left',
				tickWidth: 1,
				opposite: false,
				showEmpty: false,
				labels: {
					format: getYAxisLabelFormat(decimalPrecisionLeftYaxis),
				},

				title: {
					text: leftAxisTitle,
					align: 'middle',
				},

				// This is a custom property that DOES NOT EXIST in highcharts API documentation
				// The tooltip formatter uses this property to match the amount of decimals for the series with those of the yAxis
				decimalPrecision: decimalPrecisionLeftYaxis,
			},
			{
				id: 'y-axis-right',
				tickWidth: 1,
				showEmpty: false,
				labels: {
					align: 'left',
					format: getYAxisLabelFormat(decimalPrecisionRightYaxis),
				},
				opposite: true,
				title: {
					text: rightAxisTitle,
					align: 'middle',
				},

				// This is a custom property that DOES NOT EXIST in highcharts API documentation
				// The tooltip formatter uses this property to match the amount of decimals for the series with those of the yAxis
				decimalPrecision: decimalPrecisionRightYaxis,
			},
			{
				// A second y-axis on the right
				// https://jira.vicompany.nl/browse/BNP-2246
				id: 'y-axis-right-volatility',
				className: 'axis-volatility',
				margin: 15,
				tickWidth: 1,
				showEmpty: false,
				labels: {
					align: 'left',
					format: getYAxisLabelFormat(decimalPrecisionRightYaxis),
				},
				opposite: true,
				title: {
					text: rightSecondaryAxisTitle,
					align: 'middle',
				},

				// This is a custom property that DOES NOT EXIST in highcharts API documentation
				// The tooltip formatter uses this property to match the amount of decimals for the series with those of the yAxis
				decimalPrecision: decimalPrecisionRightYaxis,
			},
		],
	};

	return config;
};

export default getChartConfig;
